import { GraphQLResult, GRAPHQL_AUTH_MODE } from "@aws-amplify/api-graphql";
import { Layout } from "antd";
import { API } from "aws-amplify";
import React, { useEffect, useState } from "react";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import {
  Navigate,
  useLocation,
  useNavigate,
  useOutletContext,
} from "react-router";
import { useParams } from "react-router-dom";
import {
  CheckAccountStateQuery,
  CheckLiveSessionQuery,
  Game,
  GenerateGameSessionTokenBetradarMutation,
  GenerateGameSessionTokenTimelessTechMutation,
  GetGameByIdQuery,
  GetSessionDataQuery,
  SessionManagementMutation,
} from "../../API";
import { RootState } from "../../app/store";
import {
  GameModeType,
  selectCasinoTheme,
  setGameIdAction,
  setIsInAWindowAction,
  setCloseGameAction,
  setRebuyAction,
} from "../../features/casinotheme";
import {
  PlayerMode,
  selectPlayer,
  updateAccount,
} from "../../features/player/playerSlice";
import {
  Localization,
  openSidebar,
  selectTheme,
  showFooter,
  showLoading,
  ThemeMode,
} from "../../features/theme/themeSlice";
import {
  generateGameSessionTokenBetradar,
  generateGameSessionTokenTimelessTech,
  sessionManagement,
} from "../../graphql/mutations";
import {
  checkAccountState,
  checkLiveSession,
  getGameById,
  getSessionData,
} from "../../graphql/queries";
import useAccount from "../../hooks/useAccount";
import AppLocale from "../../lang";
import { ModalBuyIn } from "./ModalBuyIn";
import ModalSessionExists from "./ModalSessionExists";
import { selectConfig } from "../../features/configapp";
import PlayVirtualSideMenu from "../shared-components/PlayVirtualSideMenu";

type LocationState = {
  gameId: string;
};

const PlaySRVirtual = () => {
  const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
  const theme = useAppSelector(selectTheme);
  const player = useAppSelector(selectPlayer);
  const config = useAppSelector(selectConfig);
  const locale: Localization = theme.language as any;
  const languages: any = { it: "it-IT", en: "en-US" };
  const language = languages[locale];
  const currentAppLocale = AppLocale[locale];
  const dispatch = useDispatch();
  const location = useLocation();
  const locationState = location.state as LocationState;
  const r = new RegExp(
    "gameId=(?<gameId>[0-9]+)&gameProvider=(?<provider>[a-f0-9-]+)",
    "gmi"
  );

  const locationVars = r.exec(location.search);
  console.log(locationState);
  const [gameProvider, setGameProvider] = useState(
    (location.state as LocationState) === null
      ? locationVars[2]
      : locationState.gameId.split("#")[0]
  );
  const [gameId, setGameId] = useState<string>(
    (location.state as LocationState) === null
      ? locationVars[1]
      : locationState.gameId.split("#")[1]
  );

  const [game, setGame] = useState<Game | null>(null);
  const casinoTheme = useAppSelector(selectCasinoTheme);
  const navigate = useNavigate();
  const [sessionToken, setSessionToken] = useState(null);
  const [buyInAmount, setBuyInAmount] = useState<number | null>(null);
  const [existsSession, setExistsSession] = useState<Array<{
    __typename: "GameSession";
    PK?: string | null;
    SK?: string | null;
    lang?: string | null;
    currency?: string | null;
    username?: string | null;
    live?: string | null;
    gameId?: string | null;
    demo?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    liveUpdatedAt?: string | null;
    level?: string | null;
  }> | null>(null);

  const closeSession = (
    sessionToken: string,
    callback: (result: any) => void
  ) => {
    (async () => {
      const result: GraphQLResult<SessionManagementMutation> =
        (await API.graphql({
          query: sessionManagement,
          authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
          variables: {
            session: sessionToken,
            oper: "SESSION_CLOSE",
          },
        })) as GraphQLResult<SessionManagementMutation>;
      if (result.data.sessionManagement) {
        return result.data.sessionManagement;
      } else return null;
    })().then((r) => {
      if (callback) {
        callback(r);
      }
    });
  };

  const generateSession = (buyIn: number) => {
    console.log("generateSession::", game, player);
    if (buyIn) {
      (async () => {
        try {
          const result: GraphQLResult<GenerateGameSessionTokenBetradarMutation> =
            (await API.graphql({
              query: generateGameSessionTokenBetradar,
              authMode: player.logged
                ? GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS
                : GRAPHQL_AUTH_MODE.AWS_IAM,
              variables: {
                currency: player.account ? player.account.valute : "EUR",
                lang: language,
                gameId: `${gameProvider}#${gameId}`,
                category: game.category,
                buyIn: buyIn,
              },
            })) as GraphQLResult<GenerateGameSessionTokenBetradarMutation>;

          if (result.data.generateGameSessionTokenBetradar.length > 20)
            setSessionToken(result.data.generateGameSessionTokenBetradar);
        } catch (e) {
          console.error(e);
        }
      })();
    }
  };
  /*
  const checkSession = () => {
    const existsLiveSession: boolean = false;
    (async () => {
      try {
        const liveSession: GraphQLResult<CheckLiveSessionQuery> =
          (await API.graphql({
            query: checkLiveSession,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: {
              provider: "",
            },
          })) as GraphQLResult<CheckLiveSessionQuery>;

        if (liveSession.data !== null) {
          if (liveSession.data.checkLiveSession.length > 0) {
            liveSession.data.checkLiveSession.map((s, i) => {
              closeSession(s.PK.replace("SESSION#", ""), (r) => {
                console.log("Session closed", r);
              });
            });
            //setExistsSession(liveSession.data.checkLiveSession);
          } else {
            setExistsSession(null);
          }
        }
      } catch (error) {}
    })().catch((reason) => {
      console.log("error check live session!!!");
    });
    if (!existsLiveSession) {
      generateSession(buyInAmount);
      dispatch(showLoading(false));
    }
  };
*/
  useEffect(() => {
    if (buyInAmount) {
      generateSession(buyInAmount);
    }
  }, [buyInAmount]);

  useEffect(() => {
    if (player.username !== "") {
      //checkSession();
    }
  }, [player]);

  useEffect(() => {
    console.log("casinoTheme.closeGame");
    console.log("location ", location.search);
    if (casinoTheme.closeGame) {
      if (sessionToken) {
        closeSession(sessionToken, (r) => {
          console.log("closegameAction", r);
          if (r.success) {
            console.log("session closed", r);
            if (!casinoTheme.isInAWindow) navigate(-1);
            else window.close();
          }
        });
      } else {
        if (!casinoTheme.isInAWindow) navigate("/casino");
        else window.close();
      }
    }
  }, [casinoTheme.closeGame]);

  useEffect(() => {
    if (game) {
      setBuyInAmount(
        parseFloat(player.account.deposit.toFixed(2)) -
          parseFloat(player.account.expenses.toFixed(2)) +
          parseFloat(player.account.winnings.toFixed(2)) +
          parseFloat(player.account.bonus.toFixed(2)) -
          parseFloat(player.account.pickedUp.toFixed(2))
      );
    }
  }, [game]);

  useEffect(() => {
    const gam: any = {
      PK: "GAME",
      SK: "virtuali#sportradar#4#TTSoft Virtuals",
      apiOperator: "PGCasino_stg",
      category: "virtuali",
      gamedata:
        '{"id":10001,"title":"TTSoft Virtuals","platform":"desktop-and-mobile","type":"virtual_sports","subtype":"virtual-games","enabled":1,"fun_mode":0,"vendor":"ttsoftvirtuals","details":{"thumbnails":{"300x300":"https://media.ttfileserver.com/352/ttsoftvirtuals/300x300/10001.png","300x300-gif":"https://media.ttfileserver.com/352/ttsoftvirtuals/300x300/10001.gif","450x345-jpg":"https://media.ttfileserver.com/352/ttsoftvirtuals/450x345/10001.jpg","450x345-gif":"https://media.ttfileserver.com/352/ttsoftvirtuals/450x345/10001.gif"}}}',
      gameId: 10001,
      gameLaunchUrl:
        " https://vgcommonstaging.aitcloud.de/srvg-launcher/stable/bwg.html",
      id: "ed42bc99-3476-4194-85bd-94d928f754fd#4",
      mtype: "virtuali#virtuali",
      name: "TTSoft Virtuals",
      showLabel: "false",
      subcategory: "virtuali",
      updatedAt: "2022-10-17T12:56:47.691Z",
      urlEndPoint: "/playtmless",
      vendor: "ttsoftvirtuals",
      __typename: "GAME",
    };

    setGame(gam);
  }, []);

  useEffect(() => {
    if (casinoTheme.rebuyGame) {
      closeSession(sessionToken, (r) => {
        if (r.success) {
          (async () => {
            const result: GraphQLResult<CheckAccountStateQuery> =
              (await API.graphql({
                query: checkAccountState,
                authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
              })) as GraphQLResult<CheckAccountStateQuery>;

            setSessionToken(null);
            dispatch(updateAccount(result.data.checkAccountState));
            dispatch(setRebuyAction(false));
          })();
          setBuyInAmount(null);
        }
      });
    }
  }, [casinoTheme.rebuyGame]);

  useEffect(() => {
    if (theme.isMobile)
        dispatch(openSidebar(false))
    else
        dispatch(openSidebar(true))
}, [theme.isMobile])

  useEffect(() => {
    if ((location.state as LocationState) === null) {
      dispatch(setIsInAWindowAction(true));
    } else {
      dispatch(setIsInAWindowAction(false));
    }
    dispatch(setGameIdAction({ id: gameId, provider: gameProvider }));

    dispatch(showFooter(false));
    dispatch(setCloseGameAction(false));

    dispatch(setRebuyAction(false));

    return () => {
      console.log("sessionToken", sessionToken);
      if (sessionToken) {
        console.log("Sessione aperta!!!");
      }
    };
  }, []);

  return player.account ? (
    <Layout 
      className="game hpage"
      style={{
        padding: "0px 0",
        position: "relative",
        width: "100%",
        // overflowX: "hidden"
      }}>
      {" "}
      
         <Layout.Sider  style={{display: "contents"}} width={theme.sidebarStatus ? 287 : 0}>
            <PlayVirtualSideMenu/>
          </Layout.Sider>
       
        <Layout.Content>
          <div className="iframe-container">
            {game && sessionToken && (
              <iframe className="iframesr hpage"
                style={{
                  position: "absolute",
                  width:  "100vw",
                  height: `${
                    theme.headerStatus
                      ? "calc( 100vh - 150px )"
                      : "calc( 100vh - 70px )"
                  }`,
                  marginLeft: !theme.isMobile && (theme.sidebarStatus ? "" : "calc((100vw - 1150px) * 0.5)")
                }}
                frameBorder={0}
                width="100%"
                height="100%"
                src={`
              ${game.gameLaunchUrl}?clientId=${config.config.sportRadarOperatorId}&id=${sessionToken}&lang=en&product=${location.state.gameId}`}
                title="BetRadar"
              ></iframe>
            )}
          </div>
        </Layout.Content>
     
      {existsSession && (
        <ModalSessionExists
          playedGameId={`${gameProvider}#${gameId}`}
          sessions={existsSession}
          onContinue={() => {
            setExistsSession(null);
          }}
          onRecovery={(session) => {
            setSessionToken(session.PK.replace("SESSION#", ""));
            setExistsSession(null);
          }}
          onCloseSession={(session) => {
            if (session) {
              closeSession(session.PK.replace("SESSION#", ""), (r) => {
                console.log("Session closed", r);
              });
            }
          }}
        />
      )}
    </Layout>
  ) : (
    <div
      className="game"
      style={{
        height: "100%",
        padding: "20px 0",
        position: "relative",
        width: "100%",
      }}
    >
      No player
    </div>
  );
};

export default PlaySRVirtual;
